import { XIAppIcon, BasicTile } from '@inmoment/the-kitchen';
import React from 'react';
import { KitchenContext } from '../../../App';
import { Page } from '../../../cookbook-ui/Page_SC';
import { TitleText } from '../../../cookbook-ui/custom-components/TitleText/TitleText';
import { HeaderWrapper, SectionWrapper, UpdatePageWrapper } from '../UpdatePage/UpdatePage_SC';
import { BasicTileWrapper, MetricsWrapper } from './MetricsPage_SC';

export const MetricsPage = () => {
  const { componentMetrics } = React.useContext(KitchenContext);
  let mappedMetrics: JSX.Element[] = [];
  let integrations = 0;
  let totalUsed = 0;
  let totalComponents = 0;

  if (componentMetrics !== undefined) {
    mappedMetrics = componentMetrics
      .filter(({ 'Component Name': componentName }) => !!componentName)
      .map((component) => {
        totalComponents++;

        const componentName = component['Component Name'];
        const numberOfIntegrations = Number(component['# of Integrations']);
        integrations += numberOfIntegrations;

        if (numberOfIntegrations > 0) {
          totalUsed++;
        }

        return (
          <BasicTileWrapper key={componentName}>
            <BasicTile isInteractive={false} padding={36} style={{ display: 'flex', flexDirection: 'column', cursor: 'auto' }}>
              <p className="kxi-text-large">{componentName}</p>
              <p className="kxi-text-medium">Integrations: {numberOfIntegrations}</p>
            </BasicTile>
          </BasicTileWrapper>
        );
      });
  }

  return (
    <UpdatePageWrapper>
      <HeaderWrapper>
        <Page>
          <XIAppIcon icon="metrics" />
          <TitleText
            headerText="Metrics"
            footerText="Here you'll find usage statistics for implementations of the Kitchen Components
        across the platform, in any framework. Updated every week."
            isLargeHeader
          />
          <hr />
        </Page>
      </HeaderWrapper>
      <SectionWrapper>
        {mappedMetrics.length ? (
          <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
            <p className="kxi-text-xlarge">Total Integrations: {integrations}</p>
            <p className="kxi-text-large">
              Components Integrated: {totalUsed} / {totalComponents}{' '}
            </p>
            <br />

            <br />
            <MetricsWrapper>{mappedMetrics}</MetricsWrapper>
          </div>
        ) : (
          <>
            <br />
            <br />
            <br />
            <br />
            <p className="kxi-error kxi-text-center">
              The server providing this information is down, we are working on restoring access. Thank you for your patience.
            </p>
          </>
        )}
      </SectionWrapper>
    </UpdatePageWrapper>
  );
};

/* Component Format
 component:
 "": ""
 #: "24"
 # of Integrations: "0"
 Accessible: ""
 Admin: "0"
 Approved for Production: ""
 Available in Web Component Build: ""
 Benchmark: "0"
 Browser Compatible*: ""
 Campaign Insights: "0"
 Case Management: "0"
 Category: "Lists"
 Component Name: "ListItem"
 Convert from Styled Components: ""
 Data Exploration: "0"
 Designed: "Yes"
 Developed: ""
 Documented: ""
 Field Reporting: "0"
 Field Reporting Priority: ""
 Field Reporting Row: ""
 Instances in Production: ""
 Integrated: ""
 MXIC: "0"
 Mobile Responsive: ""
 Notes: ""
 Ready to test in Production: ""
 Reporting: "0"
 Responsive: ""
 SEO: "0"
 Testing in Production: ""
 Transition Complete: ""
 Unit Tests Written: ""
 Workflow: "0"
 Workflow Priority: ""
 Workflow Row: ""
 XI Powered Apps: "0" */
